import React from 'react';
import { useTranslation } from 'react-i18next';
import church from '../church.png';

const EventDetails = () => {
    const { t } = useTranslation();

    return (
        <section id="event-details">
            <h2>{t('ceremony_reception')}</h2>
            <div className="event-image-container"><img height="500" src={church} alt="Church" /></div>
            <p><strong>{t('date')}:</strong> 19/09/2026 <strong>{t('time')}:</strong>  17:00:00</p>
            <p><strong>{t('venue')}:</strong> Iglesia del Carmen</p>
            <p>{t('event_details_text')}</p>
            <a
                href="https://www.google.com/maps/dir//C.+Carmen,+14,+30201+Cartagena,+Murcia"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
                style={{ marginTop: '1rem', display: 'table', margin: '1rem auto' }}
            >
                {t('location_how_to_get_there')}
            </a>
        </section>
    );
};

export default EventDetails;
